export default __webpack_public_path__ + "static/media/F6.4169cb36.mp3";